import styled from "styled-components";

const PageWrapper = styled.div`
  background-color: #fff7df;
  margin: 40px 0;
  padding: 3rem 0;
  margin: 5rem 0;
  border-radius: 1rem;

  .course-type-cont {
    display: flex;
    justify-content: center;
    padding: 10px;
  }
  .button {
    display: flex;
    justify-content: center;
    margin: auto;
    padding: 15px;
  }
`;

export { PageWrapper };
